import * as React from 'react';
import { ICommentaryType } from '../../../../../commentaries/typings';
import { getSrc } from '../../../../../images/tools';
import { IMatchEventGoal } from '../../../../../matchEvents/typings';
import { IPerson } from '../../../../../people/typings';
import { getPersonUsualName } from '../../../../../people/utils';
import { Content } from '../Content.component';
import { IComponentProps } from './GoalContent.connector';

export class GoalContent extends React.Component<IComponentProps> {
  public shouldComponentUpdate(nextProps: IComponentProps) {
    const { commentary, membership } = this.props;
    return (
      !nextProps.membership ||
      !membership ||
      nextProps.commentary.type !== commentary.type ||
      nextProps.commentary.content !== commentary.content ||
      nextProps.membership.id !== membership.id
    );
  }

  public render() {
    const { commentary, membership, homeTeam, awayTeam } = this.props;
    const matchEvent = commentary.matchEvent as IMatchEventGoal;
    const { homeScore, awayScore, matchTeamPosition } = matchEvent;
    if (!membership) {
      return null;
    }
    const person = membership.person;
    const scorerTeam = this.getScorerTeam();

    const text = this.getText(person, commentary.type);
    const teamLogo = this.getTeamPhoto(scorerTeam);
    const awayTeamLargeLogo = this.getTeamLargePhoto(awayTeam);
    const homeTeamLargeLogo = this.getTeamLargePhoto(homeTeam);
    const personPhoto = this.getPersonPhoto(person);
    const homeNameClasses = matchTeamPosition === 'home' ? 'active' : '';
    const awayNameClasses = matchTeamPosition === 'away' ? 'active' : '';

    return (
      <React.Fragment>
        <div className="comment__text comment__text--highlight">
          <p className="comment__text__title">{text}</p>
        </div>
        <div className="comment__pictures">
          <div className="comment__pictures__player">{personPhoto}</div>
          <div className="comment__pictures__team comment__pictures__team--right">{teamLogo}</div>
        </div>
        <div className="comment__score">
          <div className="comment__score__team comment__score__team--home">
            <div className={`comment__score__name comment__score__name--home ${homeNameClasses}`}>
              <span>{homeTeam.name}</span>
            </div>
            {homeTeamLargeLogo}
          </div>

          <div className="comment__score__result">
            <span className={'comment__score__result--home ' + homeNameClasses}>{homeScore}</span>
            {' - '}
            <span className={'comment__score__result--away ' + awayNameClasses}>{awayScore}</span>
          </div>
          <div className="comment__score__team comment__score__team--away">
            {awayTeamLargeLogo}
            <div className={`comment__score__name comment__score__name--away ${awayNameClasses}`}>
              <span>{awayTeam.name}</span>
            </div>
          </div>
        </div>
        <Content content={commentary.content} />
      </React.Fragment>
    );
  }

  private getText = (person: IPerson, type: ICommentaryType) => {
    const {
      intl: { formatMessage: f },
    } = this.props;

    const param = { person: getPersonUsualName(person) };
    let key = '';
    switch (type) {
      case 'goal':
        key = 'live_commentary_goal_goal';
        break;
      case 'own_goal':
        key = 'live_commentary_goal_own_goal';
        break;
      case 'penalty_goal':
        key = 'live_commentary_goal_penalty_goal';
        break;
    }

    return key ? f({ id: key }, param) : '';
  };
  private getPersonPhoto = person => {
    const src = getSrc(person.photo) || '/img/person.jpg';
    return <img src={src} alt={getPersonUsualName(person)} width="70" height="70" />;
  };

  private getTeamPhoto = team => {
    return team.club.logo ? <img src={getSrc(team.club.logo, 20)} alt={team.name} width="25" height="25" /> : null;
  };
  private getTeamLargePhoto = team => {
    return team.club.logo ? <img src={getSrc(team.club.logo, 150)} alt={team.name} width="50" height="50" /> : null;
  };

  private getScorerTeam = () => {
    const { commentary, homeTeam, awayTeam } = this.props;
    const { matchEvent, type } = commentary;

    const isOwnGoal = type === 'own_goal';
    const isHome = matchEvent.matchTeamPosition === 'home';
    return isHome !== isOwnGoal ? homeTeam : awayTeam;
  };
}
